import { Box } from 'modules/v2/foundation/Box';
import { Typography } from 'modules/v2/foundation/Typography';
export function MenuItemText(props) {
    const { primary, secondary, truncate } = props;
    return (<Box flexDirection="column">
      {primary && (<Typography $truncate={truncate} $appearance="300" $fontSize="medium" $lineHeight="neutralized">
          {primary}
        </Typography>)}
      {secondary && (<Typography $truncate={truncate} $appearance="100" $fontSize="small" $lineHeight="neutralized">
          {secondary}
        </Typography>)}
    </Box>);
}
